export const config = {
	id: null,
	options: {
		accurateTrackBounce: true,
		clickmap: true,
		defer: false,
		ecommerce: false,
		params: [],
		userParams: {},
		trackHash: false,
		trackLinks: true,
		type: 0,
		webvisor: false,
		triggerEvent: false
	},
	router: null,
	env: 'development',
	scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
	debugScriptSrc: 'https://mc.yandex.ru/metrika/tag.js?_ym_debug=1',
	debug: false,
	ignoreRoutes: [],
	skipSamePath: true
};

export let YandexGoal = {
	BASKET_CLICK : 'click_main',
	BASKET_CLICK_BAY_CATALOG : 'click_catalog',
	BASKET_CLICK_BAY_DETAIL : 'click_product'
};

export default {config,YandexGoal}
